<template>
  <div class="billing-side-panel">
    <!-- User Section -->
    <div class="user-section">
      <img
        class="profile-picture"
        :src="resolvedUserProfilePicture"
        alt="User Profile"
      />
      <p class="user-name">{{ globalState.userName || "Guest" }}</p>
      <div class="points-section">
        <div class="points-content">
          <p class="points-label">Your Available Points</p>
          <p class="points-value">{{ globalState.availablePoints }}</p>
        </div>
      </div>
    </div>

    <!-- Slideshow Section -->
    <div class="slideshow-container">
      <div
        class="slideshow-wrapper"
        :style="{ transform: `translateX(-${currentImageIndex * 100}%)` }"
      >
        <div v-for="(image, index) in images" :key="index" class="slide">
          <img :src="image.url" class="slide-image" alt="Slideshow Image" />
        </div>
      </div>

      <!-- Navigation Dots -->
      <div class="dots-container">
        <span
          v-for="(image, index) in images"
          :key="index"
          class="dot"
          :class="{ active: currentImageIndex === index }"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { globalState } from "@/store/globalState";
import APIService from "@/service/APIService";
import defaultUserImage from "@/assets/user.jpg"; // Default profile picture
const urlParams = new URLSearchParams(window.location.search);
const displayId = urlParams.get("displayId") ?? null;

export default {
  props: {
    width: {
      type: String,
      default: "100dvw",
    },
    height: {
      type: String,
      default: "100dvh",
    },
    status: {
      type: String,
      default: "idle",
    },
  },
  data() {
    return {
      globalState,
      images: [],
      swiperSpeed: 4000,
      currentImageIndex: 0,
      timer: null,
    };
  },
  computed: {
    // If profile picture is missing, use the default image
    resolvedUserProfilePicture() {
      return globalState.userProfilePicture
        ? globalState.userProfilePicture
        : defaultUserImage;
    },
  },
  created() {
    this.fetchImages();
  },
  beforeUnmount() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.stopTimer();
      if (this.images.length > 1) {
        this.timer = setInterval(() => {
          this.currentImageIndex =
            (this.currentImageIndex + 1) % this.images.length;
        }, this.swiperSpeed);
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    fetchImages() {
      let path = `?status=${this.status}`;
      if (displayId) {
        path += `&displayId=${displayId}`;
      }

      const swiperImageDetails = new APIService(
        this.authToken,
        this.apiBaseURL,
        "customer-display/images" + path
      );

      swiperImageDetails
        .getData()
        .then((data) => {
          if (data.data.images && data.data.images.length > 0) {
            // Map images to object format
            this.images = data.data.images.map((url) => ({ url }));
          }

          this.swiperSpeed = Number(data.data.speed) || 4000;
          this.startTimer();
        })
        .catch((error) => {
          console.error("Error fetching images:", error);
        });
    },
  },
};
</script>

<style scoped>
.billing-side-panel {
  background-color: #221e1d;
  border-radius: 5px;
  padding: 5%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 90dvh;
  margin: auto;
}

.user-section {
  text-align: center;
  width: 85%;
  margin-top: 20px;
}

.profile-picture {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 10px;
}

.user-name {
  font-size: 1.5rem;
  font-weight: bold;
}

.points-section {
  height: 18vh;
  background-color: #100d08;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.points-content {
  text-align: center;
}

.points-label {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.points-value {
  font-size: 2rem;
  font-weight: bold;
  color: #f9a825;
}

.slideshow-container {
  width: 85%;
  height: 180px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 35px;
}

.slideshow-wrapper {
  display: flex;
  width: 100%;
  transition: transform 1s ease-in-out;
}

.slide {
  min-width: 100%;
  height: 180px;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.dots-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: gray;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.3s ease-in-out;
}

.dot.active {
  background-color: #f9a825;
}
</style>
